
export const regions = ["All", "North America", "Europe", "Asia Pacific", "Latin America", "Middle East & Africa"];
export const productLines = ["All", "Enterprise Solutions", "Cloud Services", "Security Software", "Data Analytics", "AI & Machine Learning", "NA"];
export const industries = ["All", "Telecom", "Technology", "FSI", "Manufacturing", "Public Sector", "Others"];
